import { useEffect, useRef, useState } from "react";
import { galleryItems } from "@/mocks/home";
import Reveal from "@/components/feature/Reveal";

export default function GallerySection() {
  const [toast, setToast] = useState("");
  const timerRef = useRef<number | null>(null);

  useEffect(() => {
    return () => {
      if (timerRef.current) {
        window.clearTimeout(timerRef.current);
      }
    };
  }, []);

  const handleDownload = () => {
    setToast("图集正在打包，稍后可在图文档案馆查看整理版。");
    if (timerRef.current) {
      window.clearTimeout(timerRef.current);
    }
    timerRef.current = window.setTimeout(() => setToast(""), 3200);
  };

  return (
    <section id="gallery" className="bg-background-100 py-16 md:py-24">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-8">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div className="max-w-2xl">
            <p className="font-label text-xs tracking-[0.3em] text-primary-600">ARCHIVE</p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">图文档案馆</h2>
            <p className="mt-4 text-sm leading-relaxed text-foreground-700 md:text-base">
              这里放着整理好的长图与速览卡片，版式都按「方便保存」来设计。想一次带走，直接点打包下载。
            </p>
          </div>
          <button
            type="button"
            onClick={handleDownload}
            className="flex shrink-0 cursor-pointer flex-nowrap items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 font-label text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-download-2-line"></i>
            打包下载图集
          </button>
        </div>

        <div className="relative mt-6 md:mt-8">
          {toast && (
            <div className="absolute -top-2 right-0 z-20 flex items-center gap-2 rounded-md border border-accent-300 bg-accent-50 px-4 py-2.5 font-label text-xs text-accent-900 md:text-sm">
              <i className="ri-error-warning-line"></i>
              {toast}
            </div>
          )}

          <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {galleryItems.map((item, index) => (
              <Reveal key={item.id} delay={index * 60}>
                <article className="group h-full overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-primary-300">
                  <div className="relative h-56 w-full overflow-hidden md:h-60">
                    <img
                      src={item.image}
                      alt={`${item.title} - 灵灵黑料大合集`}
                      title={`${item.title} ｜ 灵灵黑料全盘点`}
                      className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/45 via-transparent to-transparent"></div>
                    <span className="absolute bottom-3 left-3 flex items-center gap-1.5 rounded-full bg-background-50/95 px-2.5 py-1 font-label text-[11px] text-foreground-700">
                      <i className="ri-image-2-line text-primary-600"></i>
                      长图
                    </span>
                  </div>
                  <div className="p-4 md:p-5">
                    <h3 className="font-heading text-base font-bold text-foreground-950">{item.title}</h3>
                    <p className="mt-2 text-sm leading-relaxed text-foreground-600">{item.caption}</p>
                  </div>
                </article>
              </Reveal>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}